import React from 'react';

function InputField({
  label,
  Icon,
  type = 'text',
  name,
  placeholder,
  value,
  onChange,
  disabled = false,
  autoComplete,
  error,
  maxLength,
}) {
  const inputClassName = type === 'select' ? 'inputselect' : 'inputtext';
  
  return (
    <div className="form-field">
      <div className="field-label">
        {Icon ? <Icon /> : null}
        {label}
      </div>
      <div className="input-group">
        <div className="input-with-error">
          <input
            className={inputClassName}
            type={type}
            name={name}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            disabled={disabled}
            autoComplete={autoComplete}
            maxLength={maxLength}
          />
          {error && <span className="error-message">{error}</span>}
        </div>
      </div>
    </div>
  );
}

export default InputField;
